/** Pixel dimensions of an image. */
export interface ImageMetadata {
	width: number
	height: number
}

/** Loads a File as an image and resolves its natural width/height, used to attach dimensions to uploads. */
export async function extractImageMetadata(file: File): Promise<ImageMetadata> {
	return new Promise((resolve, reject) => {
		const img = new Image()
		const url = URL.createObjectURL(file)

		img.onload = () => {
			URL.revokeObjectURL(url)
			resolve({
				width: img.naturalWidth,
				height: img.naturalHeight,
			})
		}

		img.onerror = () => {
			URL.revokeObjectURL(url)
			reject(new Error("Failed to load image"))
		}

		img.src = url
	})
}
